import { response_type, list_item_type, item, result_type } from "../interfaces";
import { permissions_type } from "./permissions";

declare const permissions: permissions_type;
declare const level: string[];
declare const http_request_worker: (
  url: string,
  role: string,
  index: number,
  hostname: string,
  method_id: number,
  datacenter_name: string,
  cluster_name: string | undefined,
  namespace_name: string | undefined,
  body?: string,
  kind?: string,
  old_data?: any[] | undefined,
  no_info?: boolean,
  subscription_id?: string,
  cluster_session?: string,
  workspace_session?: string,
  unit_provide?: string,
  page?: string,
  db_data?: response_type
) => Promise<any>;

// 根據 url 陣列，用迴圈讀取所有該頁的資料
export function http_get_batch(
  list: { url: string; kind: string; no_info?: boolean }[],
  page: string,
  hostname: string,
  role: string,
  datacenter_name: string,
  cluster_name?: string,
  workspace_name?: string,
  namespace_name?: string,
  subscription_id?: string,
  unit_provide?: string
): Promise<unknown> {
  return new Promise((resolve) => {
    //     const clusters_url: string = `/v1/datacenter/${datacenter_name}/clusters${subscription_id ? `?subscriptionId=${subscription_id}` : ''}`;
    //     const level_found: number = level.indexOf(role);

    //     const rest_request = (response?: response_type): void => {
    // const cluster_name_new: string | undefined = cluster_name || (response?.items || [])[0]?.metadata?.name;
    list.forEach((list_item: list_item_type) => {
      const { url, no_datacenter }: list_item_type = list_item;
      list_item.url = `${no_datacenter ? "" : `/v1/datacenter/${datacenter_name}`}${
        cluster_name && url !== "/api/search"
          ? `/cluster/${cluster_name}${workspace_name ? `/workspace/${workspace_name}` : ""}${namespace_name ? `/namespace/${namespace_name}` : ""}`
          : ""
      }${url}`;

      role === "namespaceDeveloper" &&
        list_item.kind === "workspaces" &&
        (list_item.url = `${no_datacenter ? "" : `/v1/datacenter/${datacenter_name}`}${cluster_name ? `/cluster/${cluster_name}/workspacenames` : ""}`);
    });

    let workloads: item[] = [];
    const responses: { [key: string]: response_type } = {},
      promises: Promise<unknown>[] = list.map(
        ({ url, kind, no_info }: { url: string; kind: string; no_info?: boolean }): Promise<unknown> => {
          return new Promise((resolve_1: (value?: unknown) => void, reject: (reason?: any) => void): void => {
            const permissions_each: Int32Array = permissions[kind];
            const level_found: number = level.indexOf(role || "");
            no_info = no_info || (kind === "workspaces" && level_found === 4);
            if (level_found > -1 && permissions_each && permissions_each[level_found] > 0)
              http_request_worker(
                `${url}${subscription_id ? `${kind === "subscriptions" ? "&" : "?"}subscriptionId=${subscription_id}` : ""}`,
                role,
                0,
                hostname,
                0,
                datacenter_name,
                cluster_name,
                namespace_name,
                undefined,
                kind,
                undefined,
                no_info,
                subscription_id,
                undefined,
                undefined,
                unit_provide,
                page
              )
                .then(({ result }: result_type): void => {
                  // 如果有回傳值
                  if (result) {
                    //  如果沒有 token 或 token 失效，回傳值裡會有 message 和 status，status 會是 401，
                    //  那麼就直接把這個 Promise 拒絕，不讓剩下的http請求繼續跑完
                    if ((result as response_type).message && (result as response_type).status === 401) reject();
                    else {
                      // 這邊的回傳值有可能是字串，有可能是陣列，不過大部分情況都符合response_type
                      (result as response_type).kind = kind;
                      const items = (result as response_type).items;
                      if (page === "workload_list" && items) {
                        items.forEach(({ metadata }: item) => {
                          metadata && (metadata.type = kind.substring(0, kind.length - 1));
                        });
                        items && (workloads = items.concat(workloads));
                        responses[url] = result as response_type;
                        postMessage(JSON.stringify([{ items: workloads, kind: "workloads" }]));
                        resolve_1(result);
                      } else {
                        // 規則：回傳值必須不是字串，或者不是空的陣列才能提供給主線程顯示
                        // （因為回傳值是字串一定是 API 壞了，前端不處理這部分，容錯就好）
                        if (
                          (typeof result !== "string" || // 如果回傳值不是字串 // 或者
                            (Array.isArray(result) && result.length)) && // 如果回傳值是陣列，而且陣列不是空的
                          Object.keys(result as object).length &&
                          result
                        ) {
                          postMessage(JSON.stringify([result]));
                          responses[url] = result as response_type;
                        }
                        // 回傳給主線程後還是要結束 Promise，不然程式會卡住
                        resolve_1(result);
                      }
                    }
                    // 如果沒有回傳值還是要結束 Promise，不然程式會卡住
                  } else resolve_1();
                })
                // http_request 函數有發生錯誤還是要結束 Promise，不然程式會卡住
                .catch(() => {
                  resolve_1();
                });
            else resolve_1();
          });
        }
      );

    // other_promises = other_promises || [];
    // 全部工作完成後才結束
    Promise.all(promises).finally((): void => {
      postMessage("end");
    });
    // }

    // if (permissions.clusters[level_found] && !dont_load_clusters) {
    //     get_db('data', undefined, clusters_url).then((response: response_type) => {
    //         postMessage(JSON.stringify([response]));
    //         http_request_worker(clusters_url, role, 0, hostname, 0, datacenter_name, '', undefined, undefined, 'clusters', undefined, false, subscription_id, undefined, undefined, page, response).then(({ result }: result_type): void => {
    //             set_db('data', undefined, result, clusters_url);
    //             (result as response_type).kind = 'clusters';
    //             postMessage(JSON.stringify([result as response_type]));
    //             rest_request(result as response_type);
    //         })
    //     });
    // } else rest_request();
  });
}
